import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";
import defaultProfile from "./default";
import { commonMenuItems } from "./common";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "TableSection", props: { name: "adminList" } },
];

export default (ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  statusPageConfig: {
    ...defaultProfile(ctx).statusPageConfig,
    showRconPort: false,
  },
  configSections,
});
